<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="接待讲解" class="h-100" name="2">
      <recruit-item v-if="activeName == 2" :serviceType="activeName"></recruit-item>
    </el-tab-pane>
    <el-tab-pane label="社会教育活动" class="h-100" name="3">
      <recruit-item v-if="activeName == 3" :serviceType="activeName"></recruit-item>
    </el-tab-pane>
    <el-tab-pane label="临展报名" class="h-100" name="4">
      <recruit-item v-if="activeName == 4" :serviceType="activeName"></recruit-item>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import recruitItem from './recruit-item'
export default {
  components: {
    recruitItem
  },
  data() {
    return {
      activeName: "2",
      list: []
    }
  },

  methods: {
    handleClick(tab) {
      this.activeName = tab.name
    },
  },

  mounted() {
    this.activeName = this.$route.query.serviceType || '2'
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  /deep/.el-tabs__nav-wrap {
    &::after {
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }

  /deep/.el-tabs__content {
    flex: 1;
    overflow: auto;
    padding-bottom: 50px;
  }
}
</style>